module.exports = __webpack_public_path__ + "img/website-store-tiles-01-6_low_greeting-cards.5457df55.jpeg";